const createUnitDetailTitle = (
    name: string,
    accomomdationName: string | undefined,
    accommodationPageIsPublic: boolean
) => (accommodationPageIsPublic ? `${accomomdationName} - ${name}` : `${name}`);

export default createUnitDetailTitle;
